"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _createStyles = _interopRequireDefault(require("../utils/createStyles"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _default = theme => _objectSpread(_objectSpread({}, (0, _createStyles.default)('backgroundColor', theme.palette)), {}, {
  txt: {
    position: 'relative',
    paddingTop: 17,
    paddingBottom: 20,
    color: theme.textField.color,
    '& input': {
      color: theme.textField.color,
      backgroundColor: 'transparent',
      padding: 0,
      position: 'relative',
      width: '100%',
      border: 'none',
      outline: 'none',
      height: '100%',
      boxSizing: 'border-box'
    },
    '& textArea': {
      fontFamily: 'inherit',
      color: theme.textField.color,
      backgroundColor: 'transparent',
      padding: 0,
      position: 'relative',
      width: '100%',
      border: 'none',
      outline: 'none',
      height: '100%',
      boxSizing: 'border-box',
      resize: 'none'
    },
    '&.hasLeftIcon $label': {
      transform: 'translate(24px, 0px)'
    },
    '&.selected $label': {
      color: theme.textField.selected.colorLabel,
      fontSize: theme.textField.selected.fontSizeLabel,
      transform: 'translate(0px, -19px)'
    },
    '&.selected $field': {
      color: theme.textField.selected.color,
      borderBottomColor: theme.textField.selected.borderColor
    },
    '&.focus $field': {
      borderBottomColor: theme.textField.active.borderColor
    },
    '&.focus $label': {
      color: theme.textField.active.colorLabel
    },
    '&.focus $helperText': {
      color: theme.textField.active.colorHelper
    },
    '&.error $field': {
      color: theme.textField.error.color,
      borderBottomColor: theme.textField.error.borderColor
    },
    '&.error $label': {
      color: theme.textField.error.colorLabel
    },
    '&.error $helperText': {
      color: theme.textField.error.colorHelper
    },
    '&.hidden': {
      display: 'none'
    },
    '&.disabled': {
      opacity: theme.disabledOpacity,
      cursor: 'default'
    },
    '&$small': {
      paddingTop: 0
    },
    '&.bordered': {
      paddingTop: 20,
      '&.focus > $field': {
        borderColor: theme.textField.active.borderColor
      },
      '&.error > $field': {
        borderColor: theme.textField.error.borderColor
      },
      '& > $field': {
        borderColor: theme.textField.borderColor,
        borderWidth: 1,
        borderStyle: 'solid'
      },
      '& > $label': {
        transform: 'translate(0px, -22px)',
        fontSize: theme.textField.selected.fontSizeLabel
      },
      '&$small': {
        '& > $field': {
          borderRadius: theme.textField.bordered.borderRadiusSmall,
          paddingLeft: 8,
          paddingRight: 8,
          paddingTop: 4,
          paddingBottom: 5,
          '& > .endAdornment': {
            marginRight: -8,
            marginTop: -4,
            marginBottom: -5
          },
          '& > .startAdornment': {
            marginLeft: -8,
            marginTop: -4,
            marginBottom: -5
          }
        }
      },
      '&$medium': {
        '& > $field': {
          borderRadius: theme.textField.bordered.borderRadiusMedium,
          paddingLeft: 12,
          paddingRight: 12,
          paddingTop: 6,
          paddingBottom: 7,
          '& > .endAdornment': {
            marginRight: -12,
            marginTop: -6,
            marginBottom: -7
          },
          '& > .startAdornment': {
            marginLeft: -12,
            marginTop: -6,
            marginBottom: -7
          }
        }
      },
      '&$large': {
        '& > $field': {
          borderRadius: theme.textField.bordered.borderRadiusLarge,
          paddingLeft: 12,
          paddingRight: 12,
          paddingTop: 10,
          paddingBottom: 11,
          '& > .endAdornment': {
            marginRight: -12,
            marginTop: -10,
            marginBottom: -11
          },
          '& > .startAdornment': {
            marginLeft: -12,
            marginTop: -10,
            marginBottom: -11
          }
        },
        '& > $label': {
          transform: 'translate(0px, -24px)',
          fontSize: 14
        }
      }
    },
    '&.unspaced': {
      padding: 0,
      margin: 0
    }
  },
  field: {
    display: 'flex',
    borderBottomColor: theme.textField.borderColor,
    borderBottomWidth: 1,
    borderBottomStyle: 'solid',
    position: 'relative',
    padding: '4px 0 8px 0',
    transition: theme.transition(['all']),
    alignItems: 'center',
    /**
     * Make adornments to ignore inner field paddings in order
     * to have better flexibility and don't stretch field size
     */
    '& .endAdornment': {
      margin: '-4px 0 -8px 0'
    },
    '& .startAdornment': {
      margin: '-4px 0 -8px 0'
    }
  },
  label: {
    position: 'absolute',
    top: 20,
    zIndex: 1,
    transition: theme.transition(['all']),
    fontSize: theme.textField.fontSizeLabel,
    color: theme.textField.colorLabel,
    transform: 'translate(0px, 0px)',
    transformOrigin: 'left top 0px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    maxWidth: '100%',
    '&.unspaced': {
      top: 0
    }
  },
  leftIcon: {
    marginRight: 12,
    display: 'flex',
    alignItems: 'center'
  },
  rightIcon: {
    marginLeft: 24,
    display: 'flex',
    alignItems: 'center'
  },
  colorBadge: {
    marginRight: 12,
    display: 'flex',
    alignItems: 'center',
    borderWidth: 0
  },
  helperText: {
    fontSize: theme.textField.fontSizeHelper,
    color: theme.textField.colorHelper,
    marginTop: 4
  },
  small: {
    '& input': {
      fontSize: theme.textField.fontSizeSmall
    },
    '& textArea': {
      fontSize: theme.textField.fontSizeSmall
    }
  },
  medium: {
    '& input': {
      fontSize: theme.textField.fontSizeMedium
    },
    '& textArea': {
      fontSize: theme.textField.fontSizeMedium
    },
    '& input::placeholder': {
      color: theme.textField.placeholder
    }
  },
  large: {
    '& input': {
      fontSize: theme.textField.fontSizeMedium
    },
    '& textArea': {
      fontSize: theme.textField.fontSizeMedium
    },
    '& input::placeholder': {
      color: theme.textField.placeholder
    }
  },
  passIcon: {
    marginLeft: 24,
    marginBottom: 1,
    display: 'flex',
    alignSelf: 'center',
    cursor: 'pointer'
  },
  popup: {
    marginTop: '-20px',
    '&.unspaced': {
      marginTop: 0
    }
  }
});
exports.default = _default;